import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Analytics from '../../Components/Analytics';
import Mobile from '../../Components/Mobile';

export default () => {
    return <div className="flex flex-col items-center justify-center h-screen">
        <div className="md:max-w-[400px] max-w-[90%] w-full -mt-[20%]">
            <ErrorBoundary>
                <DialoguesWrapper>
                    <HelpWrapper>
                        <Mobile>
                            <ErrorBoundary>
                                <Outlet />
                            </ErrorBoundary>
                        </Mobile>
                    </HelpWrapper>
                </DialoguesWrapper>
                <Analytics />
            </ErrorBoundary>
        </div>
    </div>
}
